import { filter, property, some } from 'lodash'
import { createSlice, createSelector } from '@reduxjs/toolkit'


const
  SINGLE_COMPONENT_TYPES = [ 'isPin', 'isI2COutput', 'isPWM', 'isServo', 'isPixel', 'isDisplay' ],
  MULTI_COMPONENT_TYPES = [ 'isI2C', 'isDS18X20', 'isUART' ]

const { actions, reducer } = createSlice({
  name: 'componentTypes',

  initialState: {
    componentTypes: {}
  },

  reducers: {
    setComponentTypes: (state, { payload: componentTypes }) => ({ ...state, componentTypes }),
  },
})

export const
  // ACTIONS
  { setComponentTypes } = actions,

  // SELECTORS
  selectState = property('componentTypes'),

  selectAllComponentTypes = createSelector([selectState], property('componentTypes')),

  selectMultiComponentTypes = createSelector([selectAllComponentTypes], allTypes =>
    filter(Object.values(allTypes), type => some(MULTI_COMPONENT_TYPES, prop => type[prop]))
  ),

  selectSingleComponentTypes = createSelector([selectAllComponentTypes], allTypes =>
    filter(Object.values(allTypes), type => some(SINGLE_COMPONENT_TYPES, prop => type[prop]))
  )


export default reducer
